import { useEffect } from "react";

/**
 * Componente custom per la gesione del localStorage ad apertura Edit.
 * Aggiunto all'interno del componente <Edit> di ogni risorsa.
 */

const useManageOpenEditTabs = (resource, id) => {
  useEffect(() => {
    // Se la modalità a schede multiple è disattivata non viene eseguito
    const ModeOpenTabsOn = localStorage.getItem("ModeOpenTabsOn");
    if (ModeOpenTabsOn === "false") {
      return;
    }

    if (!resource || !id) return;

    const handleBeforeUnload = () => {
      const raw = localStorage.getItem("openEditTabs");
      if (!raw) return;

      let openTabs = JSON.parse(raw);
      if (!openTabs[resource]) openTabs[resource] = [];

      openTabs[resource] = openTabs[resource].filter((i) => i !== id);
      localStorage.setItem("openEditTabs", JSON.stringify(openTabs));

      const bc = new BroadcastChannel("editTabs");
      bc.postMessage(openTabs);
      bc.close();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      handleBeforeUnload(); // anche on unmount
    };
  }, [resource, id]);
};

export default useManageOpenEditTabs;
